import React, { useState } from 'react'
import { Fab } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import { makeStyles } from '@material-ui/core/styles'

import PopupForm from '../Form/PopupForm'

const useStyles = makeStyles((theme) => ({
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    backgroundColor: '#000',
    borderRadius: '3px',
    color: '#fff',
    '&:hover': {
      background: 'linear-gradient(90deg, #92fe9d 0%, #00C9FF 100%)',
    },
  },
}))

const FloatingButton = ({ currentId, setCurrentId, login }) => {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const user = JSON.parse(localStorage.getItem('profile'))

  const handleClickOpen = () => {
    setCurrentId(0)
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <div>
      <Fab
        className={classes.fab}
        variant='extended'
        aria-label='like'
        size='medium'
        onClick={user?.result ? handleClickOpen : login}
      >
        <AddIcon />
        Create Room
      </Fab>
      <PopupForm
        open={open}
        handleClose={handleClose}
        currentId={currentId}
        setCurrentId={setCurrentId}
      />
    </div>
  )
}

export default FloatingButton
